import React from 'react'
import * as ROLES from 'app/constants/roles'

import './styles.scss'

export const bc = 'role-name'

const RoleName = ({ t, roleName }) => {
  const renderRoleName = roleName => {
    switch (roleName) {
      case ROLES.SUPER_ADMIN:
        return (
          <span>
            {t('super')}
            <br /> {t('admin')}
          </span>
        )

      case ROLES.MULTI_ADMIN:
        return (
          <span>
            {t('multi')}
            <br /> {t('admin')}
          </span>
        )
      case ROLES.ADMIN:
        return t('admin')
      default:
        return null
    }
  }
  return ROLES.USER !== roleName ? <div className={bc}>{renderRoleName(roleName)}</div> : null
}

export default RoleName
